module.exports = new __parcel__URL__("multiple-channel-dark.2f977ec6.svg").toString();